import React from 'react';

const Filtros = props => (
  <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>
    

      <div className='row'>
      <div className='col-sm-6'>
      <div class="form-group">
      <label class="labelInfo" for="asesorComercial">Buscar certificado</label>
      
      <input 
              style={{width:'400px'}}
              class="form-control awesomplete" 
              placeholder="Buscar certificado"    
              type='text'
              name='buscar'
              id='buscar'
               value={props.buscar}
               onChange={props.onChangeAndFilter}
               onKeyDown={(e) => {
                 if (e.keyCode === 13) {
                   e.preventDefault();
                   props.searchCertificado();
                 }
               }}
               />
      </div>
      </div>
      </div>
      
    </div>
  </div>
);

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/MantAreadeVenta/Filtros.js